import { read, utils, writeFile, type WorkBook, type WorkSheet } from "xlsx"

export async function readXlsxFile<T = Record<string, unknown>>(file: string, sheet: string): Promise<T[]> {
  let workbook: WorkBook
  if (import.meta.server) {
    const fs = await import("fs/promises")
    const buffer = await fs.readFile(`./public` + file)
    workbook = read(buffer, { type: "buffer" });
  }
  if (import.meta.client) {
    const binary = await $fetch(file, { responseType: "arrayBuffer" })
    workbook = read(binary, { type: "binary" });
  }

  const worksheet = workbook!.Sheets[sheet]!
  const records = utils.sheet_to_json<Record<string, unknown>>(worksheet)

  return records as T[]
}


export function downloadXlsxFile(filename: string, sheet: string, records: Record<string, unknown>[], customize?: (workbook: WorkBook, worksheet: WorkSheet) => void) {
  const worksheet = utils.json_to_sheet(records)
  const workbook = utils.book_new()
  utils.book_append_sheet(workbook, worksheet, sheet)
  customize?.(workbook, worksheet)
  writeFile(workbook, filename, { compression: true });
}
